import { getRequest, postRequest } from '../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { createSearchParams, useParams } from 'react-router-dom'
import {
  HarnessListContext,
  SET_HARNESS_DATA,
  SET_SELECTED_HARNESS_DATA,
  SHOW_HIDE_HARNESS_SALES_CODE_POPUP,
} from './context/context'
import HarnessRow from './HarnessRow'
import CreateUpdateHarness from './form'
import InputText from '../../common/InputText'
import Button from '../../common/Button'
import HarnessSalesCodeRelations from './relation'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const HarnessList = (props) => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(NavContext)
  const [harnessState, harnessDispatch] = useContext(HarnessListContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`
  const currentUrl = useRef(
    `/api/harnesses/?vehicle=${vehicle}&search=${searchValue}`
  )

  useEffect(() => {
    getHarnessList(null)

    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / Harness`,
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  const getHarnessList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Harness Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(currentUrl.current)
    harnessDispatch({ type: SET_HARNESS_DATA, data: response.results })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteHarness = async (harness) => {
    if (
      window.confirm(
        `Are you sure want to delete ${harness.harness_id}, It will delete respective records.`
      )
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Harness Delete is in progress',
          showLoader: true,
        },
        notification: {},
      })
      let res = await postRequest(`/api/harnesses/harness_delete/${vehicle}/`, {
        harness_id: harness.harness_id,
        vehicle: vehicle,
      })
      getHarnessList()
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Harness Deleted Successfully`,
        },
      })
    }
  }

  return (
    <div className="w-full">
      <CreateUpdateHarness
        showModal={showModal}
        setShowModal={setShowModal}
        getHarnessList={getHarnessList}
      />
      {harnessState?.harnessSalesCodePopup?.id && <HarnessSalesCodeRelations />}

      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          currentUrl.current = `/api/harnesses/?vehicle=${vehicle}&search=${searchValue}`
          getHarnessList()
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Harness`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
            </div>
            <Button
              className={`cursor-pointer btn my-4 justify-end`}
              text={`Search`}
              onClick={() => {}}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-4/12 pl-10 items-center">Harness Id</div>
          <div className="flex w-2/12 pl-6 items-center">Part Number</div>
          <div className="w-2/12 pl-6 items-center">Abbreviation</div>
          <div className="w-2/12 pl-6 items-center">Harness Type</div>
          <div className="w-2/12 pl-6 items-center"></div>
        </div>
      </div>
      {harnessState?.data?.map((harness, index) => {
        return (
          <HarnessRow
            {...harness}
            key={`harness-${index}`}
            onEdit={() => {
              harnessDispatch({
                type: SET_SELECTED_HARNESS_DATA,
                data: { ...harness, index: index },
              })
              setShowModal(true)
            }}
            onDelete={() => {
              deleteHarness(harness)
            }}
            showRelatedData={() => {
              harnessDispatch({
                type: SHOW_HIDE_HARNESS_SALES_CODE_POPUP,
                data: { ...harness, index: index },
              })
            }}
          />
        )
      })}
      {harnessState?.data?.length < 1 && (
        <NoRecordsFound caption={"Sales code's not found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getHarnessList()
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getHarnessList()
          }}
        />
      </div>
    </div>
  )
}

export default HarnessList
